import template from './adminToolSection.html';
import controller from './adminToolSection.controller';

let adminToolSectionComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default adminToolSectionComponent;



// WEBPACK FOOTER //
// ./app/components/adminToolSection/adminToolSection.component.js